import { render, staticRenderFns } from "./simplifyRoomFee.vue?vue&type=template&id=49aff8ca&scoped=true"
import script from "./simplifyRoomFee.vue?vue&type=script&lang=js"
export * from "./simplifyRoomFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyRoomFee.vue?vue&type=style&index=0&id=49aff8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aff8ca",
  null
  
)

export default component.exports